module.exports = __webpack_public_path__ + "img/greenLogo.4d152ae8.svg";